import Base from './Base';
import { USER_ROLES } from '../modules/user';
import { utils } from '../modules/analytics';

export default class Member extends Base {
    constructor(item) {
        super(item);

        if (!item.last_name) this.last_name = '';
        if (!item.first_name) this.first_name = '';
        if (!item.full_name) this.full_name = '';
    }

    get fullName() {
        let fullName = '';

        if (this.full_name) {
            return this.full_name;
        }

        if (this.first_name) {
            fullName += this.first_name;
        }

        if (this.last_name) {
            if (this.first_name) {
                fullName += ` ${this.last_name}`;
            } else {
                fullName += this.last_name;
            }
        }

        return fullName;
    }

    get name() {
        return this.fullName;
    }

    get formattedNumber() {
        if (!this.number) return '';

        return this.number.formatted_number;
    }

    get isAvatar() {
        return Boolean(this.photo_url);
    }

    get isDefaultAvatar() {
        if (!this.photo_url) return false;

        return this.photo_url.endsWith(`/images/app/default-avatar.png`);
    }

    get src() {
        if (!this.isAvatar) {
            return false;
        }

        if (this.photo_url.indexOf('gravatar') !== -1) {
            return `${this.photo_url}`;
        }

        return this.photo_url;
    }

    get color() {
        const palette = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return palette[this.id % palette.length];
    }

    get roleClass() {
        return this.role === 'owner' ? 'is-primary' : 'tag-info';
    }

    get isOwnerRole() {
        return this.role === 'owner';
    }

    get isViewOnlyRole() {
        return this.role === USER_ROLES.VIEW_ONLY;
    }

    get isMemberRole() {
        return this.role === USER_ROLES.MEMBER;
    }

    get isManagerRole() {
        return this.role === USER_ROLES.MANAGER;
    }

    get isAdminRole() {
        return this.role === USER_ROLES.ADMIN;
    }

    get roleLabel() {
        if (this.isViewOnlyRole) {
            return 'Observer';
        }

        if (this.isMemberRole) {
            return 'Member';
        }

        if (this.isManagerRole) {
            return 'Manager';
        }

        if (this.isAdminRole) {
            return 'Admin';
        }

        return 'Owner';
    }

    get hasStatusRequestedInboxAccess() {
        return this.has_inbox_access_request;
    }

    get hasChangeRoleRequest() {
        return this.has_change_role_request;
    }

    get statusLabel() {
        if (this.hasStatusRequestedInboxAccess) {
            return 'Requested Inbox Access';
        } else if (this.hasChangeRoleRequest) {
            return 'Requested Role update';
        }

        return this.countInboxes === 1
            ? `${this.countInboxes} inbox`
            : `${this.countInboxes} inboxes`;
    }

    get countInboxes() {
        if (typeof this.member_teams_count !== 'number') {
            return 0;
        }

        return this.member_teams_count;
    }

    get statusColor() {
        if (this.hasStatusRequestedInboxAccess || this.hasChangeRoleRequest) {
            return '#d8524e';
        }

        if (this.countInboxes === 0) {
            return '#e6b05f';
        }

        return 'inherit';
    }

    get avgTimeToClose() {
        if (!this.avg_time_to_close) return utils.formatDinamic(0, 3);

        return utils.formatDinamic(Math.round(Math.abs(this.avg_time_to_close)) * 1000, 3);
    }

    get avgTimeToFirstResponse() {
        if (!this.avg_time_to_first_response) return utils.formatDinamic(0, 3);

        return utils.formatDinamic(Math.round(Math.abs(this.avg_time_to_first_response)) * 1000, 3);
    }

    get avgTimeToResponse() {
        if (!this.avg_time_to_response) return utils.formatDinamic(0, 3);

        return utils.formatDinamic(Math.round(Math.abs(this.avg_time_to_response)) * 1000, 3);
    }
}
